import { createAsyncThunk } from '@reduxjs/toolkit'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../../common/selectCurrencyUnit/slice'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'
import { mapAllVNDValue } from '../../../helper'

export const getSecuEarningBreakdownThunk = createAsyncThunk(
  'financialAnalysis/Secu/GET_EARNING_BREAKDOWN',
  async (data, { rejectWithValue, dispatch }) => {
    const response = await FinancialAnalysisService.getEarningBreakdown(data)
    if (response.success) {
      dispatch(
        calculateDefaultUnit({
          screen: SCREEN.FINANCIAL_ANALYSIS,
          getValues: () => mapAllVNDValue(response.data),
        }),
      )
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadSecuEarningBreakdown = createAsyncThunk(
  'financialAnalysis/Secu/DOWNLOAD_EARNING_BREAKDOWN',
  async (data) => {
    const response = await FinancialAnalysisService.downloadEarningBreakdown(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
